import Flickity from 'flickity';

import debounce from '../util/debounce';
import {register} from '../vendor/theme-scripts/theme-sections';

const sections = {};

const selectors = {
  logo: '[data-slider-logo]',
  text: '[data-slider-text]',
  slide: '[data-slide]',
  slideData: 'data-slide',
  asNavFor: '#nav-for-',
  prevArrow: '[data-prev-arrow]',
  nextArrow: '[data-next-arrow]',
  slideIndex: 'data-slide-index',
  flickityEnabled: 'flickity-enabled',
  classIsSelected: 'is-selected',
};

class LogoList {
  constructor(section) {
    this.container = section.container;
    this.slideshowText = this.container.querySelector(selectors.text);
    this.slideshowNav = this.container.querySelector(selectors.logo);
    this.slideshowPrev = this.container.querySelector(selectors.prevArrow);
    this.slideshowNext = this.container.querySelector(selectors.nextArrow);
    this.logoSlides = this.slideshowNav.querySelectorAll(selectors.slide);
    this.textSlides = this.slideshowText.querySelectorAll(selectors.slide);
    this.flkty = null;
    this.flktyNav = null;

    this.init();
  }

  init() {
    this.flkty = new Flickity(this.slideshowText, {
      autoPlay: false,
      prevNextButtons: false,
      contain: true,
      pageDots: false,
      wrapAround: false,
      selectedAttraction: 0.3,
      friction: 0.8,
      draggable: false,
    });

    this.logoSlides.forEach((element) => {
      element.addEventListener(
        'click',
        function (e) {
          const index = parseInt(e.currentTarget.getAttribute(selectors.slideIndex));
          const hasSlider = this.slideshowNav.classList.contains(selectors.flickityEnabled);

          this.flkty.select(index);
          if (hasSlider) {
            this.flktyNav.select(index);
          } else {
            this.logoSlides.forEach((logo) => {
              logo.classList.remove(selectors.classIsSelected);
            });
            e.currentTarget.classList.add(selectors.classIsSelected);
          }
        }.bind(this)
      );
    });

    let maxHeight = -1;
    if (this.textSlides) {
      this.textSlides.forEach((element) => {
        const elementHeight = parseFloat(getComputedStyle(element, null).height.replace('px', ''));

        if (elementHeight > maxHeight) {
          maxHeight = elementHeight;
        }
      });

      this.textSlides.forEach((element) => {
        const elementHeight = parseFloat(getComputedStyle(element, null).height.replace('px', ''));

        if (elementHeight < maxHeight) {
          const calculateMargin = Math.ceil((maxHeight - elementHeight) / 2);
          element.style.margin = `${calculateMargin}px 0`;
        }
      });
    }

    this.initSlideshowNav();
  }

  onUnload() {
    const sliderInitialized = this.slideshowNav.classList.contains(selectors.flickityEnabled);
    if (sliderInitialized) {
      this.flktyNav.destroy();
    }

    this.flkty.destroy();
  }

  onBlockSelect(evt) {
    const slide = this.slideshowText.querySelector(`[${selectors.slideData}="${evt.detail.blockId}"]`);
    const slideIndex = parseInt(slide.getAttribute(selectors.slideIndex));
    const sliderInitialized = this.slideshowNav.classList.contains(selectors.flickityEnabled);

    if (sliderInitialized) {
      this.flktyNav.select(slideIndex);
      this.flktyNav.stopPlayer();
    }

    this.flkty.select(slideIndex);
    this.flkty.stopPlayer();
  }

  onBlockDeselect() {
    const sliderInitialized = this.slideshowNav.classList.contains(selectors.flickityEnabled);
    if (sliderInitialized) {
      this.flktyNav.playPlayer();
    }
  }

  goToPrevSlide(e) {
    e.preventDefault();

    this.flktyNav.previous(true);
    this.flkty.previous(true);
  }

  goToNextSlide(e) {
    e.preventDefault();

    this.flktyNav.next(true);
    this.flkty.next(true);
  }

  initSlideshowNav() {
    this.slideshowPrev.addEventListener('click', this.goToPrevSlide.bind(this));

    this.slideshowNext.addEventListener('click', this.goToNextSlide.bind(this));

    const setSlideshowNavState = () => {
      const slidesCount = this.slideshowNav.querySelectorAll(selectors.slide).length;
      const slideWidth = 200;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const slidesWidth = slidesCount * slideWidth;
      const sliderInitialized = this.slideshowNav.classList.contains(selectors.flickityEnabled);

      if (slidesWidth > windowWidth) {
        if (!sliderInitialized) {
          this.logoSlides.forEach((logo) => {
            logo.classList.remove(selectors.classIsSelected);
          });

          this.flktyNav = new Flickity(this.slideshowNav, {
            autoPlay: false,
            prevNextButtons: false,
            contain: true,
            pageDots: false,
            selectedAttraction: 0.05,
            friction: 0.8,
          });
        }
      } else if (sliderInitialized) {
        this.flktyNav.destroy();
        this.logoSlides[0].classList.add(selectors.classIsSelected);
      }
    };

    setSlideshowNavState();

    window.addEventListener('resize', debounce(setSlideshowNavState.bind(this), 200));
  }
}

const LogoListSection = {
  onLoad() {
    sections[this.id] = new LogoList(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('logos', LogoListSection);
